import { createContext } from 'react';

import type { PetitionMitaAlternateImageData } from 'src/app/pages/petition/details/shared/types';

export const MitaContext = createContext<PetitionMitaAlternateImageData | undefined>(undefined);
